import {
    SAVE_ORCHESTRATION_CACHE,
    SAVE_ROUTE_INFO,
    USER_LOGGED_IN,
    RECEIVE_CART_ITEMS,
    APP_INITIALIZED,
    RECEIVE_PROFILE,
    RANDOMIZE_BANNER,
    SET_TRACER_VALUE,
    GOOGLE_MAPS_READY,
    NAVIGATION_LOADED,
    RECIEVE_SIMPLE_INFO_MODAL
} from '../actions/initialActions';

import {
    SAVE_EMAIL_SIGN_UP_DATA,
    SIGN_UP_FOR_EMAIL_SUCCESS,
    SIGN_UP_FOR_EMAIL_ERROR,
    CLEAR_EMAIL_SIGN_UP_FORM,
    CHANGE_EMAIL_OPTIN_SOURCE,
    SET_EMAIL_SIGNUP_STICKY_STATE
} from '../actions/emailSignupActions';

import {
    emailSignUpComponentName as footerEmailSignUpComponentName
} from '../components/footerComponent';

import { emailSignUpReducer } from '../reducers/emailSignupReducer';
import { favoritesReducer } from './favoritesReducer';
import { heartsReducer } from './heartsReducer';

import {
    EDIT_SITE_SEARCH,
    TOGGLE_SITE_NAV,
    TOGGLE_SITE_SEARCH,
    SAYT_DISABLE_NO_SUGGESTIONS_MESSAGE,
    SAYT_SEARCH_RESULTS,
    ENHANCED_SAYT_SEARCH_RESULTS,
    SAYT_SEARCH_FAILURE,
    UPDATE_COUNTRY_AND_CURRENCY
} from '../actions/headerActions';

import { SHOW_SITE_MESSAGE, RESET_SITE_MESSAGE } from '../actions/siteMessageActions';
import {
    CLEAR_LOGIN_DATA,
    LOGIN_DATA,
    LOGIN_FAILURE,
    SIGNUP_FAILURE,
    SIGNUP_DATA,
    SIGNOUT_SUCCESS,
    LOGIN_SUCCESS,
    SEND_PASSWORD_DATA,
    SEND_PASSWORD_RESET_SUCCESS,
    SEND_PASSWORD_RESET_FAILURE,
    RECEIVE_LOYALTY_SUBSCRIPTION,
    RECEIVE_USER_ADDRESSES,
    RECEIVE_USER_PREFERENCES,
    RECEIVE_USER_TRAITS,
    LOYALTY_VIEW_READY,
    SEND_EMAIL_SIGNUP_DATA,
    CLEAR_EMAIL_SIGNUP_DATA,
    SAVE_EMAIL_SIGNUP_DATA,
    EMAIL_SIGNUP_FAILURE,
    STICKY_SIGNUP_SUCCESS,
    DISABLE_LOYALTY_MODAL,
    UPDATE_LOYALTY_USERNAME,
    SET_LOYALTY_STATUS
} from '../actions/userActions';

import {
    ORDER_STATUS_DATA,
    ORDER_STATUS_SUCCESS,
    ORDER_STATUS_FAILURE
} from '../actions/orderStatusActions';

import {
    SHOW_VIDEO
} from '../actions/tileControlsActions';

import { SAVE_DEFAULT_URBN_STORE } from '../actions/bopisActions';

import {
    SET_REGIONS,
    SET_SELECTED_COUNTRY,
    SET_GROUP_TYPE_FOR_SELECTED_COUNTRY,
    SET_GROUP_TYPE
} from '../actions/countrySelectActions';

import {
    RECEIVE_PRIMARY_HEADER_PROMO_BANNER,
    RECEIVE_GENERIC_PROMO_BANNER
} from '../actions/promoBannerActions';

import {
    CHANGE_STYLIST_PREFERRED_LOCATION,
    CHANGE_STYLE_PREFERENCE,
    CHANGE_APPOINTMENT_TYPE,
    CHANGE_HOME_TYPE,
    CHANGE_ROOM_PREFERENCE,
    CHANGE_MONTH_FOR_PREFERRED_FIRST_CHOICE,
    CHANGE_DAY_FOR_PREFERRED_FIRST_CHOICE,
    CHANGE_TIME_FOR_PREFERRED_FIRST_CHOICE,
    CHANGE_MONTH_FOR_PREFERRED_SECOND_CHOICE,
    CHANGE_DAY_FOR_PREFERRED_SECOND_CHOICE,
    CHANGE_TIME_FOR_PREFERRED_SECOND_CHOICE,
    SET_STORES_FOR_PERSONAL_SHOPPER,
    SET_EMAIL_FOR_PERSONAL_SHOPPER,
    SET_EMAIL_FOR_PERSONAL_SHOPPER_STORE,
    SET_EMAIL_FOR_PERSONAL_SHOPPER_HOME_STYLIST
} from '../../../help/js/actions/helpActions';

import { USER_AGREED_TO_COOKIES, USE_GOCATSS } from '../actions/cookiesAlertActions';

import {
    HIDE_CART_CONFIRM,
    CANCEL_HIDE_CART_CONFIRM_TIMER,
    RESET_HIDE_CART_CONFIRM_TIMER,
    SET_FREE_SHIPPING_FLAG,
    ADDED_TO_CART,
    SET_MARKETPLACE_EMAIL_AUTOFILL
} from '@product/js/actions/productActions';

import {
    QUICKSHOP_SAGAS_INITIALIZED
} from '@product/js/enums/quickshopEnums';

import {
    SAVE_RR,
    RR_ERROR
} from '../actions/richRelevanceActions';

import {
    RECEIVE_CATEGORY_ITEMS,
    UPDATE_WITHOUT_REQUEST
} from '../../../category/js/actions/requestActions';

import {
    PROFILE_AVAILABILITY_ERROR,
    PROFILE_AVAILABILITY_SUCCESS,
    LOYALTY_SIGNUP_FAILURE,
    SAVE_LOYALTY_VALIDATION,
    LOYALTY_SIGNUP_SUCCESS,
    LOYALTY_LOGIN_SUCCESS,
    SAVE_LOYALTY_FORM_DATA,
    SET_LOYALTY_BIRTHDAY_YEARS,
    SET_LOYALTY_BIRTHDAY_ORDER
} from '../../../loyalty/js/actions/loyaltyActions';

import {
    TRACK_ORIGIN_COMPONENT
} from '../actions/modalActions';

import { merge, reduceOneObjectInArray } from '../utils/reducerUtils';

import {
    GENERIC_EMAIL_SERVICE_SUCCESS,
    GENERIC_EMAIL_SERVICE_ERROR,
    SAVE_GENERIC_EMAIL_VALIDATION,
    RESET_GENERIC_EMAIL_SUCCESS_STATE
} from '../actions/genericEmailServiceActions';

import {
    SAVE_UGCS,
    SAVE_UGC_POSTS,
    SAVE_UGC_SELECTED_INDEX,
    CLEAR_UGC_SELECTED_INDEX,
    SAVE_UGC_TRAY,
    SAVE_UGC_SELECTED_FILTER
} from '../actions/ugcActions';

import {
    SEND_FIND_REGISTRY_DATA,
    CLEAR_REGISTRY_DATA
} from '../actions/findRegistryModalActions';

import {
    SEND_USER_NAME_DATA,
    CLEAR_USER_NAME_DATA,
    USER_NAME_ERROR
} from '../actions/userNameActions';

import { UPDATED_SIZE } from '../actions/deviceActions';
import { SITE_SWITCHING_ACTIVE } from '../actions/interstitialActions';

import { SET_SELECTED_LEVEL_1_NAV_SLUG, SET_SELECTED_LEVEL_2_NAV_SLUG } from '../actions/navigationActions';

import {
    USER_DISMISSED_PRIVACY_NOTICE,
    USER_HAS_OPTED_OUT,
    USER_IS_POLICY_RESIDENT
} from '@core/js/actions/privacyPreferencesActions';

const coreReducers = [
    mainCoreReducer,
    favoritesReducer,
    heartsReducer
];

function getStateForCartConfirmReset() {
    return {
        showConfirm: false,
        confirmViewModel: {
            message: ''
        }
    };
}

export function coreReducer(state = {}, action) {

    for (let i = 0; i < coreReducers.length; i++) {
        const subReducer = coreReducers[i];
        const newState = subReducer(state, action);

        // if state has passed through and not been reduce,
        // pass off to the next reducer
        if (newState !== state) {
            return newState;
        }
    }

    return state;
}

// TODO rip apart into smaller reducers
export function mainCoreReducer(state, action) {
    switch (action.type) {
        case RECIEVE_SIMPLE_INFO_MODAL:
            return Object.assign(
                {},
                state,
                { 'simpleInfoModal': action.payload }
            );

        case SHOW_SITE_MESSAGE:
        case RESET_SITE_MESSAGE:
            return Object.assign(
                {}, state, {
                    siteMessage: action.payload
                }
            );

        case SAVE_ORCHESTRATION_CACHE:
            return Object.assign(
                {}, state, action.payload.cache.core
            );
        case USER_LOGGED_IN:
            return Object.assign(
                {}, state, {
                    loggedIn: action.payload.loggedIn
                }
            );
        case RECEIVE_CART_ITEMS:
            return Object.assign(
                {}, state, {
                    cart: Object.assign(
                        {}, state.cart, {
                            bagCount: action.payload.count,
                            discountableSubtotal: action.payload.discountableSubtotal,
                            meta: action.payload.meta
                        }
                    )
                }
            );
        case RECEIVE_PROFILE:
            return Object.assign(
                {}, state, {
                    profile: Object.assign({}, state.profile, action.payload)
                }
            );
        case RECEIVE_LOYALTY_SUBSCRIPTION:
            return Object.assign(
                {}, state, {
                    profile: Object.assign(
                        {}, state.profile, {
                            loyalty: action.payload
                        }
                    )
                }
            );
        case RECEIVE_USER_ADDRESSES:
            return Object.assign(
                {}, state, {
                    profile: Object.assign(
                        {}, state.profile, {
                            hasAddresses: true
                        }
                    )
                }
            );
        case RECEIVE_USER_TRAITS:
            return Object.assign(
                {}, state, {
                    profile: Object.assign(
                        {}, state.profile, {
                            traits: action.payload
                        }
                    )
                }
            );
        case NAVIGATION_LOADED:
            return Object.assign({}, state, {
                flatNavigation: action.payload
            });
        case TOGGLE_SITE_NAV:
            return Object.assign(
                {}, state, {
                    header: Object.assign(
                        {}, state.header, {
                            siteNav: action.payload.shouldOpen,
                            siteSearch: false
                        }
                    )
                }
            );
        case TOGGLE_SITE_SEARCH:
            return Object.assign(
                {}, state, {
                    header: Object.assign(
                        {}, state.header, {
                            siteSearch: action.payload.shouldOpen,
                            siteNav: false
                        }
                    ),
                    sayt: Object.assign(
                        {}, state.sayt, {
                            header: Object.assign(
                                {}, state.sayt.header, {
                                    isClearable: false
                                }
                            )
                        }
                    )
                }
            );

        case EDIT_SITE_SEARCH:
            return Object.assign(
                {}, state, {
                    sayt: Object.assign(
                        {}, state.sayt, {
                            [action.payload.source]: Object.assign(
                                {}, state.sayt[action.payload.source], action.payload
                            )
                        }
                    )
                }
            );

        case RECEIVE_CATEGORY_ITEMS:
            return Object.assign(
                {}, state, {
                    routeInfo: Object.assign(
                        {}, state.routeInfo, {
                            currentPage: action.payload.requestedPage,
                            categoryId: action.payload.categoryId,
                            sortOptions: action.payload.sortOptions,
                            searchTerm: action.payload.searchTerm,
                            isSearch: action.payload.isSearch,
                            queryString: action.payload.queryString
                        }
                    ),
                    primaryHeaderPromo: merge(
                        state.primaryHeaderPromo,
                        action.payload.data.category.primaryHeaderPromo
                    ),
                    primaryFooterPromo: merge(
                        state.primaryFooterPromo,
                        action.payload.data.category.primaryFooterPromo
                    ),
                    secondaryFooterPromo: merge(
                        state.secondaryFooterPromo,
                        action.payload.data.category.secondaryFooterPromo
                    )
                }
            );
        case HIDE_CART_CONFIRM:
            const cartConfirmStateUpdate = action.payload && action.payload.reset ?
                getStateForCartConfirmReset() :
                { showConfirm: false };

            return Object.assign(
                {}, state, {
                    cart: Object.assign(
                        {}, state.cart, cartConfirmStateUpdate
                    )
                }
            );
        case CANCEL_HIDE_CART_CONFIRM_TIMER:
        case RESET_HIDE_CART_CONFIRM_TIMER:
            return Object.assign(
                {}, state, {
                    cart: Object.assign(
                        {}, state.cart, {
                            isConfirmTimerActive: action.payload.isConfirmTimerActive
                        }
                    )
                }
            );

        case SET_FREE_SHIPPING_FLAG:
            return Object.assign(
                {}, state, {
                    cart: Object.assign(
                        {}, state.cart, {
                            qualifiedForFreeShipping: action.payload.qualifiedForFreeShipping
                        }
                    )
                }
            );

        case UPDATE_WITHOUT_REQUEST:
            return Object.assign(
                {}, state, {
                    routeInfo: Object.assign(
                        {}, state.routeInfo, {
                            currentPage: action.payload.currentPage,
                            categoryId: action.payload.categoryId,
                            searchTerm: action.payload.searchTerm,
                            isSearch: action.payload.isSearch,
                            queryString: action.payload.queryString
                        }
                    )
                }
            );

        case ADDED_TO_CART:
            const haveClosenessQualifierCookie = _.get(action.payload.confirmViewModel, 'haveClosenessQualifierCookie', false);
            let bagCount = state.cart.bagCount;
            let discountableSubtotal = state.cart.discountableSubtotal;

            if (!haveClosenessQualifierCookie) {
                bagCount += action.payload.quantityRequested;
                discountableSubtotal += action.payload.priceForQuantity;
            }

            return Object.assign(
                {}, state, {
                    cart: Object.assign(
                        {}, state.cart, {
                            showConfirm: action.payload.showConfirm,
                            confirmViewModel: action.payload.confirmViewModel,
                            isConfirmTimerActive: action.payload.isConfirmTimerActive,
                            bagCount: bagCount,
                            discountableSubtotal: discountableSubtotal
                        }
                    )
                }
            );
        case SAVE_ROUTE_INFO:
            return Object.assign(
                {}, state, {
                    routeInfo: action.payload.routeInfo
                }
            );

        case SHOW_VIDEO:
            return Object.assign(
                {}, state, {
                    tileControls: Object.assign(
                        {}, state.tileControls, {
                            showVideo: action.payload.showVideo
                        }
                    )
                }
            );

        case SAVE_DEFAULT_URBN_STORE:
            return Object.assign({}, state, {
                productBopis: action.payload.productBopis
            });

        case CLEAR_LOGIN_DATA:
            return Object.assign(
                {}, state, {
                    modal: {}
                });

        case LOGIN_DATA:
            return Object.assign(
                {}, state, {
                    modal: Object.assign(
                        {}, state.modal, {
                            login: Object.assign(
                                {}, state.modal.login, action.payload.data, {
                                    messages: action.payload.msgs
                                }
                            )
                        }
                    )
                }
            );

        case LOGIN_FAILURE:
            return Object.assign(
                {}, state, {
                    modal: Object.assign(
                        {}, state.modal, {
                            login: Object.assign(
                                {}, state.modal.login, {
                                    messages: action.payload
                                }
                            )
                        }
                    )
                }
            );
        case LOGIN_SUCCESS:
            return Object.assign(
                {}, state, {
                    loggedIn: true,
                    modal: Object.assign(
                        {}, state.modal, {
                            data: action.payload.data
                        }
                    )
                }
            );

        case SIGNOUT_SUCCESS:
            return Object.assign(
                {}, state, {
                    loggedIn: false
                }
            );

        case SIGNUP_DATA:
            return Object.assign(
                {}, state, {
                    modal: Object.assign(
                        {}, state.modal, {
                            create: Object.assign(
                                {}, state.modal.create, action.payload.data, {
                                    messages: action.payload.msgs
                                }
                            )
                        }
                    )
                }
            );

        case SIGNUP_FAILURE:
            return Object.assign(
                {}, state, {
                    modal: Object.assign(
                        {}, state.modal, {
                            create: Object.assign(
                                {}, state.modal.create, {
                                    messages: action.payload
                                }
                            )
                        }
                    )
                }
            );

        case SEND_PASSWORD_DATA:
            return Object.assign(
                {}, state, {
                    modal: Object.assign(
                        {}, state.modal, {
                            forgotPassword: Object.assign(
                                {}, state.modal.forgotPassword, action.payload.data, {
                                    messages: action.payload.msgs
                                }
                            )
                        }
                    )
                }
            );

        case SEND_PASSWORD_RESET_SUCCESS:
            return Object.assign(
                {}, state, {
                    modal: Object.assign(
                        {}, state.modal, {
                            forgotPassword: Object.assign(
                                {}, state.modal.forgotPassword, {
                                    email: '',
                                    showPasswordResetSent: true,
                                    messages: []
                                }
                            )
                        }
                    )
                }
            );
        case SEND_PASSWORD_RESET_FAILURE:
            return Object.assign(
                {}, state, {
                    modal: Object.assign(
                        {}, state.modal, {
                            forgotPassword: Object.assign(
                                {}, state.modal.forgotPassword, {
                                    showPasswordResetSent: false,
                                    messages: action.payload
                                }
                            )
                        }
                    )
                }
            );

        case ORDER_STATUS_DATA:
            return Object.assign(
                {}, state, {
                    modal: Object.assign(
                        {}, state.modal, {
                            orderStatus: Object.assign(
                                {}, state.modal.orderStatus, action.payload.data, {
                                    messages: action.payload.msgs
                                }
                            )
                        }
                    )
                }
            );

        case ORDER_STATUS_SUCCESS:
            return Object.assign(
                {}, state, {
                    modal: Object.assign(
                        {}, state.modal, {
                            orderStatus: Object.assign(
                                {}, state.modal.orderStatus, {
                                    data: action.payload.data
                                }
                            )
                        }
                    )
                }
            );
        case ORDER_STATUS_FAILURE:
            return Object.assign(
                {}, state, {
                    modal: Object.assign(
                        {}, state.modal, {
                            orderStatus: Object.assign(
                                {}, state.modal.orderStatus, {
                                    error: action.error,
                                    data: action.payload.data,
                                    messages: {
                                        generalErrors: [action.payload.data.message]
                                    }
                                }
                            )
                        }
                    )
                }
            );

        case SAYT_SEARCH_RESULTS:
            return Object.assign(
                {}, state, {
                    sayt: Object.assign(
                        {}, state.sayt, {
                            [action.payload.source]: Object.assign(
                                {}, state.sayt[action.payload.source], action.payload
                            )
                        }
                    )
                }
            );

        case ENHANCED_SAYT_SEARCH_RESULTS:
            // if defaultTrending is already in the state, keep it
            let defaultTrending = _.get(state, `sayt.${action.payload.source}.defaultTrending`);
            let defaultProducts = _.get(state, `sayt.${action.payload.source}.defaultPopularProducts`);
            let popularDisplayName = _.get(state, `sayt.${action.payload.source}.popularDisplayName`, '');

            if (_.isEmpty(defaultTrending)) {
                defaultTrending = action.payload.defaultTrending;
            }

            if (_.isEmpty(defaultProducts)) {
                defaultProducts = action.payload.defaultPopularProducts;
            }

            if (_.isEmpty(popularDisplayName)) {
                popularDisplayName = action.payload.popularDisplayName;
            }

            return Object.assign(
                {}, state, {
                    sayt: Object.assign(
                        {}, state.sayt, {
                            [action.payload.source]: Object.assign(
                                {}, state.sayt[action.payload.source], action.payload, {
                                    defaultTrending: defaultTrending,
                                    defaultPopularProducts: defaultProducts,
                                    popularDisplayName: popularDisplayName
                                }
                            )
                        }
                    )
                }
            );

        case SAYT_SEARCH_FAILURE:
            return Object.assign(
                {}, state, {
                    sayt: Object.assign(
                        {}, state.sayt, {
                            [action.payload.source]: Object.assign(
                                {}, state.sayt[action.payload.source], {}
                            )
                        }
                    )
                }
            );

        case SAYT_DISABLE_NO_SUGGESTIONS_MESSAGE:
            return Object.assign(
                {}, state, {
                    sayt: Object.assign(
                        {}, state.sayt, {
                            [action.payload.source]: Object.assign(
                                {}, state.sayt[action.payload.source], action.payload
                            )
                        }
                    )
                }
            );

        case APP_INITIALIZED:
            return Object.assign(
                {}, state, {
                    initialized: true
                }
            );

        case SAVE_RR:
            return Object.assign({}, state, {
                rrRecs: Object.assign({}, state.rrRecs, {
                    [action.payload.placementKey]: action.payload
                })
            });

        case RR_ERROR:
            return Object.assign(
                {}, state, {
                    errors: Object.assign({}, state.errors, {
                        [action.error.location]: action.error
                    })
                }
            );

        case RANDOMIZE_BANNER:
            return Object.assign(
                {}, state, {
                    secondaryFooterPromo: action.payload.fields
                }
            );

        case RECEIVE_PRIMARY_HEADER_PROMO_BANNER:
            return Object.assign(
                {}, state, {
                    primaryHeaderPromo: action.payload.promoData
                }
            );

        case RECEIVE_GENERIC_PROMO_BANNER:
            return Object.assign(
                {}, state, {
                    [action.payload.promoKey]: action.payload.promoData
                }
            );

        case SITE_SWITCHING_ACTIVE:
            return Object.assign(
                {}, state, {
                    siteSwitchingActive: action.payload.siteSwitchingActive
                }
            );

        case SET_TRACER_VALUE:
            return Object.assign(
                {}, state, {
                    profile: Object.assign(
                        {}, state.profile, {
                            tracerValue: action.payload.tracerValue
                        }
                    )
                }
            );

        case SAVE_EMAIL_SIGN_UP_DATA:
        case SIGN_UP_FOR_EMAIL_SUCCESS:
        case SIGN_UP_FOR_EMAIL_ERROR:
            if (_.get(action, 'meta.component.name') === footerEmailSignUpComponentName) {
                return Object.assign({}, state, {
                    footer: Object.assign({}, state.footer, {
                        emailSignUp: emailSignUpReducer(state.footer.emailSignUp, action)
                    })
                });
            }
            return state;

        case SET_REGIONS:
            return Object.assign(
                {}, state, {
                    regions: action.payload.regions
                }
            );

        case SET_SELECTED_COUNTRY:
            return Object.assign(
                {}, state, {
                    genericEmailService: Object.assign(
                        {}, state.genericEmailService, {
                            selectedCountry: action.payload.selectedCountry
                        }
                    )
                }
            );

        case USER_AGREED_TO_COOKIES:
            return Object.assign(
                {}, state, {
                    userHasAgreedToCookies: action.payload.userAgreedToCookies,
                    clientsideCookieDetectionSet: true
                }
            );

        case USER_DISMISSED_PRIVACY_NOTICE:
            return Object.assign(
                {}, state, {
                    privacyRestriction: Object.assign(
                        {}, state.privacyRestriction, {
                            userHasDismissedPrivacyNotice: action.payload.userDismissedPrivacyNotice
                        }
                    )
                }
            );

        case USER_HAS_OPTED_OUT:
            return Object.assign(
                {}, state, {
                    privacyRestriction: Object.assign(
                        {}, state.privacyRestriction, {
                            userHasOptedOut: action.payload.userHasOptedOut
                        }
                    )
                }
            );

        case USER_IS_POLICY_RESIDENT:
            return Object.assign(
                {}, state, {
                    privacyRestriction: Object.assign(
                        {}, state.privacyRestriction, {
                            userIsResident: action.payload.userIsResident
                        }
                    )
                }
            );

        case USE_GOCATSS:
            return Object.assign(
                {}, state, {
                    gocatssIsActive: action.payload.gocatssIsActive,
                    gocatssDebuggerIsActive: action.payload.gocatssDebuggerIsActive
                }
            );

        case PROFILE_AVAILABILITY_ERROR:
            return Object.assign(
                {}, state, {
                    loyaltyForm: Object.assign(
                        {}, state.loyaltyForm, {
                            errors: {
                                messages: Object.assign({}, state.loyaltyForm.errors.messages, {
                                    emailAddress: [action.payload.code]
                                })
                            }
                        }
                    )
                }
            );
        case PROFILE_AVAILABILITY_SUCCESS:
            return Object.assign(
                {}, state, {
                    loyaltyForm: Object.assign(
                        {}, state.loyaltyForm, {
                            errors: {
                                messages: Object.assign({}, state.loyaltyForm.errors.messages, {
                                    emailAddress: ''
                                })
                            }
                        }
                    )
                }
            );
        case SET_LOYALTY_STATUS:
            return Object.assign(
                {}, state, {
                    loyalty: action.payload.loyalty
                }
            );
        case LOYALTY_SIGNUP_FAILURE:
            return Object.assign(
                {}, state, {
                    loyaltyForm: Object.assign(
                        {}, state.loyaltyForm, {
                            errors: {
                                messages: action.payload
                            }
                        }
                    )
                }
            );
        case SAVE_LOYALTY_VALIDATION:
            return Object.assign(
                {}, state, {
                    loyaltyForm: Object.assign(
                        {}, state.loyaltyForm, {
                            errors: {
                                values: action.payload.values,
                                messages: action.payload.msgs
                            }
                        }
                    )
                }
            );
        case LOYALTY_SIGNUP_SUCCESS:
            return Object.assign(
                {}, state, {
                    loyaltyForm: Object.assign(
                        {}, state.loyaltyForm, {
                            signupSuccess: true
                        }
                    )
                }
            );
        case SET_LOYALTY_BIRTHDAY_YEARS:
            return Object.assign(
                {}, state, {
                    loyaltyForm: Object.assign(
                        {}, state.loyaltyForm, {
                            birthdayYears: action.payload
                        }
                    )
                }
            );
        case SET_LOYALTY_BIRTHDAY_ORDER:
            return Object.assign(
                {}, state, {
                    loyaltyForm: Object.assign(
                        {}, state.loyaltyForm, {
                            birthdayFieldsOrder: action.payload
                        }
                    )
                }
            );
        case LOYALTY_LOGIN_SUCCESS:
            return Object.assign(
                {}, state, {
                    loggedIn: true
                }
            );
        case RECEIVE_USER_PREFERENCES:
            return Object.assign(
                {}, state, {
                    profile: Object.assign(
                        {}, state.profile, {
                            webPreferences: action.payload
                        }
                    )
                }
            );
        case LOYALTY_VIEW_READY:
            return Object.assign(
                {}, state, {
                    loyaltyForm: Object.assign(
                        {}, state.loyaltyForm, {
                            viewReady: true
                        }
                    )
                }
            );
        case DISABLE_LOYALTY_MODAL:
            return Object.assign(
                {}, state, {
                    loyaltyForm: Object.assign(
                        {}, state.loyaltyForm, {
                            disableModal: action.payload.disableModal
                        }
                    )
                }
            );
        case TRACK_ORIGIN_COMPONENT:
            return Object.assign(
                {}, state, {
                    modal: Object.assign(
                        {}, state.modal, {
                            originComponent: action.payload.componentName
                        }
                    )
                }
            );
        case SAVE_LOYALTY_FORM_DATA:
            return Object.assign(
                {}, state, {
                    loyaltyForm: Object.assign(
                        {}, state.loyaltyForm, {
                            data: action.payload
                        }
                    )
                }
            );
        case GENERIC_EMAIL_SERVICE_SUCCESS:
            return Object.assign(
                {}, state, {
                    genericEmailService: Object.assign(
                        {}, state.genericEmailService, {
                            state: 'submitted',
                            error: false
                        }
                    )
                }
            );
        case GENERIC_EMAIL_SERVICE_ERROR:
            return Object.assign(
                {}, state, {
                    genericEmailService: Object.assign(
                        {}, state.genericEmailService, {
                            state: 'submitted',
                            error: true,
                            response: action.payload.response
                        }
                    )
                }
            );
        case SAVE_GENERIC_EMAIL_VALIDATION:
            return Object.assign(
                {}, state, {
                    genericEmailService: Object.assign(
                        {}, state.genericEmailService, {
                            errors: {
                                values: action.payload.values,
                                messages: action.payload.msgs
                            }
                        }
                    )
                }
            );

        case RESET_GENERIC_EMAIL_SUCCESS_STATE:
            return Object.assign(
                {}, state, {
                    genericEmailService: Object.assign(
                        {}, state.genericEmailService, {
                            state: '',
                            errors: {
                                messages: {}
                            },
                            response: ''
                        }
                    )
                }
            );

        case SEND_EMAIL_SIGNUP_DATA:
        case EMAIL_SIGNUP_FAILURE:
            return Object.assign(
                {}, state, {
                    [action.payload.storeRoot]: Object.assign(
                        {}, state[action.payload.storeRoot], {
                            emailSignup: Object.assign(
                                {}, state[action.payload.storeRoot].emailSignup, action.payload.data, {
                                    messages: action.payload.msgs
                                }
                            )
                        }
                    )
                }
            );

        case STICKY_SIGNUP_SUCCESS:
            return Object.assign(
                {}, state, {
                    footer: Object.assign(
                        {}, state.footer, {
                            emailSignup: Object.assign(
                                {}, state.footer.emailSignup, {
                                    signUpSuccessful: true
                                }
                            )
                        }
                    )
                }
            );

        case CLEAR_EMAIL_SIGN_UP_FORM:
            return Object.assign({}, state, {
                modal: Object.assign({}, state.modal, {
                    emailSignup: Object.assign({}, state.modal.emailSignup, {
                        email: '',
                        messages: [],
                        optInSource: null
                    })
                })
            });

        case CLEAR_EMAIL_SIGNUP_DATA:
            const signUpSuccessful = _.get(state[action.payload.storeRoot], 'emailSignup.signUpSuccessful');
            const newObj = {};

            if (signUpSuccessful) {
                newObj.signUpSuccessful = signUpSuccessful;
            }

            return Object.assign(
                {}, state, {
                    [action.payload.storeRoot]: Object.assign(
                        {}, state[action.payload.storeRoot], {
                            emailSignup: newObj
                        }
                    )
                }
            );

        case SAVE_EMAIL_SIGNUP_DATA:
            return Object.assign(
                {}, state, {
                    modal: Object.assign(
                        {}, state.modal, {
                            emailSignup: Object.assign(
                                {}, state.modal.emailSignup, action.payload.formData
                            )
                        }
                    )
                }
            );

        case SET_EMAIL_SIGNUP_STICKY_STATE:
            return Object.assign(
                {}, state, {
                    footer: Object.assign(
                        {}, state.footer, {
                            emailSignup: Object.assign(
                                {}, state.footer.emailSignup, {
                                    emailSignupIsFixed: action.payload.isFixed
                                }
                            )
                        }
                    )
                }
            );

        case CHANGE_STYLIST_PREFERRED_LOCATION:
            return Object.assign(
                {}, state, {
                    genericEmailService: Object.assign(
                        {}, state.genericEmailService, {
                            personalStylistLocation: action.payload.preferredLocation
                        }
                    )
                }
            );

        case CHANGE_STYLE_PREFERENCE:
            return Object.assign(
                {}, state, {
                    genericEmailService: Object.assign(
                        {}, state.genericEmailService, {
                            stylePreference: action.payload.stylePreference
                        }
                    )
                }
            );

        case CHANGE_APPOINTMENT_TYPE:
            return Object.assign(
                {}, state, {
                    genericEmailService: Object.assign(
                        {}, state.genericEmailService, {
                            appointmentType: action.payload.appointmentType
                        }
                    )
                }
            );

        case CHANGE_HOME_TYPE:
            return Object.assign(
                {}, state, {
                    genericEmailService: Object.assign(
                        {}, state.genericEmailService, {
                            homeType: action.payload.homeType
                        }
                    )
                }
            );

        case CHANGE_ROOM_PREFERENCE:
            return Object.assign(
                {}, state, {
                    genericEmailService: Object.assign(
                        {}, state.genericEmailService, {
                            roomPreference: action.payload.roomPreference
                        }
                    )
                }
            );

        case CHANGE_MONTH_FOR_PREFERRED_FIRST_CHOICE:
            return Object.assign(
                {}, state, {
                    genericEmailService: Object.assign(
                        {}, state.genericEmailService, {
                            firstChoiceMonth: action.payload.firstChoiceMonth
                        }
                    )
                }
            );

        case CHANGE_DAY_FOR_PREFERRED_FIRST_CHOICE:
            return Object.assign(
                {}, state, {
                    genericEmailService: Object.assign(
                        {}, state.genericEmailService, {
                            firstChoiceDay: action.payload.firstChoiceDay
                        }
                    )
                }
            );

        case CHANGE_TIME_FOR_PREFERRED_FIRST_CHOICE:
            return Object.assign(
                {}, state, {
                    genericEmailService: Object.assign(
                        {}, state.genericEmailService, {
                            firstChoiceTime: action.payload.firstChoiceTime
                        }
                    )
                }
            );

        case CHANGE_MONTH_FOR_PREFERRED_SECOND_CHOICE:
            return Object.assign(
                {}, state, {
                    genericEmailService: Object.assign(
                        {}, state.genericEmailService, {
                            secondChoiceMonth: action.payload.secondChoiceMonth
                        }
                    )
                }
            );

        case CHANGE_DAY_FOR_PREFERRED_SECOND_CHOICE:
            return Object.assign(
                {}, state, {
                    genericEmailService: Object.assign(
                        {}, state.genericEmailService, {
                            secondChoiceDay: action.payload.secondChoiceDay
                        }
                    )
                }
            );

        case CHANGE_TIME_FOR_PREFERRED_SECOND_CHOICE:
            return Object.assign(
                {}, state, {
                    genericEmailService: Object.assign(
                        {}, state.genericEmailService, {
                            secondChoiceTime: action.payload.secondChoiceTime
                        }
                    )
                }
            );

        case SET_STORES_FOR_PERSONAL_SHOPPER:
            return Object.assign(
                {}, state, {
                    genericEmailService: Object.assign(
                        {}, state.genericEmailService, {
                            storesForPersonalShopper: action.payload.storesForPersonalShopper
                        }
                    )
                }
            );

        case SET_EMAIL_FOR_PERSONAL_SHOPPER:
            return Object.assign(
                {}, state, {
                    genericEmailService: Object.assign(
                        {}, state.genericEmailService, {
                            stylistEmail: action.payload.stylistEmail
                        }
                    )
                }
            );

        case SET_EMAIL_FOR_PERSONAL_SHOPPER_STORE:
            return Object.assign(
                {}, state, {
                    genericEmailService: Object.assign(
                        {}, state.genericEmailService, {
                            storeEmail: action.payload.storeEmail
                        }
                    )
                }
            );

        case SET_EMAIL_FOR_PERSONAL_SHOPPER_HOME_STYLIST:
            return Object.assign(
                {}, state, {
                    genericEmailService: Object.assign(
                        {}, state.genericEmailService, {
                            homeStylistEmail: action.payload.homeStylistEmail
                        }
                    )
                }
            );

        case SET_GROUP_TYPE_FOR_SELECTED_COUNTRY:
            return Object.assign(
                {}, state, {
                    validations: Object.assign(
                        {}, state.validations, {
                            address: action.payload.groupType
                        }
                    )
                }
            );
        case SET_GROUP_TYPE:
            return Object.assign(
                {}, state, {
                    currentGroupType: action.payload.groupType
                }
            );

        case CHANGE_EMAIL_OPTIN_SOURCE:
            return Object.assign(
                {}, state, {
                    [action.payload.storeLocation]: Object.assign(
                        {}, state.modal, {
                            emailSignup: Object.assign(
                                {}, state.modal.emailSignup, {
                                    optInSource: action.payload.optInSource
                                }
                            )
                        }
                    )
                }
            );

        case SAVE_UGCS:
            return Object.assign(
                {}, state, {
                    ugc: action.payload
                }
            );

        case SAVE_UGC_POSTS: {
            const index = action.payload.index;
            const ugc = Object.assign(_.get(state, `ugc.${index}`, {}), action.payload.data);

            return Object.assign(
                {}, state, {
                    ugc: reduceOneObjectInArray(_.get(state, 'ugc', []),
                        action.payload.index, ugc)
                }
            );
        }

        case SAVE_UGC_SELECTED_INDEX:
        case CLEAR_UGC_SELECTED_INDEX:
        case SAVE_UGC_TRAY: {
            const index = action.payload.index;
            const ugc = _.get(state, `ugc.${index}`, {});

            ugc.tray = Object.assign(_.get(ugc, 'tray', {}), action.payload.tray);

            return Object.assign(
                {}, state, {
                    ugc: reduceOneObjectInArray(_.get(state, 'ugc', []),
                        action.payload.index, ugc)
                }
            );
        }

        case SAVE_UGC_SELECTED_FILTER: {
            const index = action.payload.index;
            const ugc = _.get(state, `ugc.${index}`, {});
            ugc.activeFilter = action.payload.filter;

            return Object.assign(
                {}, state, {
                    ugc: reduceOneObjectInArray(_.get(state, 'ugc', []),
                        action.payload.index, ugc)
                }
            );
        }

        case SEND_FIND_REGISTRY_DATA:
            return Object.assign(
                {}, state, {
                    modal: Object.assign(
                        {}, state.modal, {
                            findRegistry: Object.assign(
                                {}, state.modal.findRegistry, action.payload.data, {
                                    messages: action.payload.msgs
                                }
                            )
                        }
                    )
                }
            );

        case CLEAR_REGISTRY_DATA:
            return Object.assign(
                {}, state, {
                    modal: {}
                });

        case UPDATED_SIZE:
            return Object.assign(
                {}, state, {
                    deviceCharacteristics: Object.assign(
                        {}, state.deviceCharacteristics, action.payload
                    )
                }
            );

        case SEND_USER_NAME_DATA:
            return Object.assign(
                {}, state, {
                    modal: Object.assign(
                        {}, state.modal, {
                            userName: Object.assign(
                                {}, state.modal.userName, action.payload.data, {
                                    messages: action.payload.msgs
                                }
                            )
                        }
                    )
                }
            );

        case CLEAR_USER_NAME_DATA:
            return Object.assign(
                {}, state, {
                    modal: {}
                });

        case USER_NAME_ERROR:
            return Object.assign(
                {}, state, {
                    modal: Object.assign(
                        {}, state.modal, {
                            userName: Object.assign(
                                {}, state.modal.userName, {
                                    messages: action.payload.msgs
                                }
                            )
                        }
                    )
                }
            );

        case UPDATE_COUNTRY_AND_CURRENCY:
            return Object.assign({}, state, {
                country: action.payload.country,
                countryDisplayName: action.payload.countryDisplayName,
                currency: action.payload.currency,
                currencyFormattingInfo: action.payload.currencyFormattingInfo
            });

        case SET_SELECTED_LEVEL_1_NAV_SLUG:
            return Object.assign({}, state, {
                selectedLevel1NavSlug: action.payload.slug
            });

        case SET_SELECTED_LEVEL_2_NAV_SLUG:
            return Object.assign({}, state, {
                selectedLevel2NavSlug: action.payload.slug
            });

        case GOOGLE_MAPS_READY:
            return Object.assign({}, state, {
                googleMapsReady: true
            });

        case UPDATE_LOYALTY_USERNAME:
            return Object.assign(
                {}, state, {
                    profile: Object.assign(
                        {}, state.profile, {
                            loyaltyUserName: action.payload.username
                        }
                    )
                }
            );

        case QUICKSHOP_SAGAS_INITIALIZED:
            return Object.assign({}, state, {
                quickshopSagasInitialized: action.payload
            });

        case SET_MARKETPLACE_EMAIL_AUTOFILL:
            return Object.assign(
                {}, state, {
                    profile: Object.assign(
                        {}, state.profile, {
                            emailAddress: action.payload
                        }
                    )
                }
            );

        default:
            return state;
    }
}
